module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_short_description_pic.fc4dbfea.svg";